'use client';

import HomeContent from '@/components/Desktop/HomeContent';
import HomeMobile from '@/components/Mobile/Home';
import { useIsMobile } from '@/components/DeviceContext';
import { useProjects } from '@/components/ProjectsContext';

export default function HomePageContent() {
  const isMobile = useIsMobile();
  const projects = useProjects();
  return isMobile
    ? <HomeMobile projects={projects} />
    : <HomeContent projects={projects} />;
}
